const translations = {
    applicationNameDuplicateError: 'Application Name Duplicate Error',
    connectionError: 'Connection Error',
    saveFailed: 'Save Failed'
};

export default translations;
